import React from "react";
import { icons } from "../../../../enums/PetIcons";
import { SPECIES_SAVE } from "../../../../enums/ApiPaths";
import { Box, Button, Grid, Stack } from "@mui/material";
import { CRIMSON_RED } from "../../../../enums/Colors";
import { useTranslation } from "react-i18next";
import usePrimaryColor from "../../../../hooks/usePrimaryColor";
import useSingleSpecies from "../hooks/useSingleSpecies";
import { SPECIES_MASTER } from "../../../../enums/QueryKeys";
import usePut from "../../../../hooks/usePut";

export default function IconSelector({ id }) {
  const { t } = useTranslation();
  const banIcon = "fa-ban";
  const color = usePrimaryColor();
  const { species: pet } = useSingleSpecies(id);
  const preselect = pet?.icon ? pet?.icon : banIcon;
  const [selectedIcon, setSelectedIcon] = React.useState(preselect);
  const submittion = usePut(SPECIES_SAVE, SPECIES_MASTER);
  function handleSubmit(e) {
    e.preventDefault();
    const obj = parseSubmitData();
    submittion.submitCallback(obj);
  }

  function parseSubmitData() {
    var obj = {
      ...pet,
      icon: selectedIcon,
    };
    if (selectedIcon === banIcon) {
      return {
        ...obj,
        icon: null,
      };
    }
    return obj;
  }

  function bgcolor(icon) {
    if (icon === banIcon && selectedIcon == banIcon) {
      return CRIMSON_RED;
    } else {
      return selectedIcon === icon ? color : "grayText";
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Stack spacing={2}>
        <Grid container gap={1}>
          {icons.map((icon, index) => (
            <Grid
              item
              key={index}
              onClick={() => setSelectedIcon(icon.icon)}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                height: 75,
                width: 75,
                backgroundColor: bgcolor(icon.icon),
                boxShadow: selectedIcon === icon.icon ? 3 : 0,
                borderRadius: 2,
              }}
            >
              <i
                className={`fas ${icon.icon}`}
                style={{
                  fontSize: 35,
                  color: "white",
                }}
              />
            </Grid>
          ))}
        </Grid>
        <Box>
          <Button variant="contained" color="info" type="submit">
            {t("Save")}
          </Button>
        </Box>
      </Stack>
    </form>
  );
}
